<template>
  <v-container>
    <v-form>
      <v-row>
        <v-container>
          <v-row wrap>
            <v-col cols="12" class="headline"
              >PERSONA QUE ENTREGA EL EQUIPO (COLABORADOR PROSIC)</v-col
            >
            <v-col cols="12">
              <v-text-field
                v-model="nameDelivered"
                outlined
                label="Nombre completo de la persona que entrega"
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="text-center">
              <canvas
                ref="canvas"
                id="canvas"
                class="text-center"
                v-on:mousedown="handleMouseDown"
                v-on:mouseup="handleMouseUp"
                v-on:mousemove="handleMouseMove"
                v-on:touchstart="handleMouseDown"
                v-on:touchmove="handleMouseMove"
                :width="sizeScreen"
                height="200px"
              ></canvas>
            </v-col>
            <v-col cols="5">
              <v-btn block color="accent" class="black--text" @click="clean"
                >Limpiar</v-btn
              >
            </v-col>
            <v-col cols="1"></v-col>
            <v-col cols="6">
              <v-btn block color="accent" class="black--text" @click="saveImg"
                >Siguiente</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { mapActions } from "vuex";
import { errorMessage } from "@/services/MessageService";

export default {
  data() {
    return {
      idItems: "995432",
      nameDelivered: "",
      url: "",
      width: 320,
      lines: [],
      correctionX: 0,
      correctionY: 0,
      mouse: {
        current: {
          x: 0,
          y: 0
        },
        previous: {
          x: 0,
          y: 0
        },
        down: false
      }
    };
  },
  computed: {
    ...mapState("checklist", ["checklistRef"]),
    sizeScreen() {
      return screen.width * 0.825;
    },
    currentMouse: function() {
      var canvasRef = this.$refs.canvas;
      var rect = canvasRef.getBoundingClientRect();
      return {
        x: this.mouse.current.x - rect.left,
        y: this.mouse.current.y - rect.top
      };
    },
    isTransferRoute() {
      if (
        this.$route.name === "signChecklistTransportistTransfer" ||
        this.$route.name === "signChecklistReceptorTransfer"
      )
        return true;
      else return false;
    }
  },
  props: ["type", "eventType", "step", "path"],
  methods: {
    ...mapActions("checklist", ["saveSignChecklistTransportist"]),
    draw: function(event) {
      event.preventDefault();

      // requestAnimationFrame(this.draw);
      if (this.mouse.down) {
        var canvasRef = this.$refs.canvas;

        var canvas = canvasRef.getContext("2d");

        canvas.clearRect(0, 0, this.width, 200);
        let nuevaPositionX = 0;
        let nuevaPositionY = 0;
        if (event.changedTouches == undefined) {
          nuevaPositionX = event.layerX;
          nuevaPositionY = event.layerY;
        } else {
          nuevaPositionX = event.changedTouches[0].pageX - this.correctionX;
          nuevaPositionY = event.changedTouches[0].pageY - this.correctionY;
        }
        canvas.lineJoin = canvas.lineCap = "round";
        canvas.strokeStyle = "#000";
        canvas.lineWidth = 2;
        // Guarda la linea
        this.lines[this.lines.length - 1].push({
          x: nuevaPositionX,
          y: nuevaPositionY
        });
        // Redibuja todas las lines guardadas
        canvas.beginPath();
        this.lines.forEach(function(segment) {
          if (segment[0]) {
            canvas.moveTo(segment[0].x, segment[0].y);
            segment.forEach(function(point) {
              if (point.x && point.y) {
                canvas.lineTo(point.x, point.y);
              }
            });
          }
        });
        canvas.stroke();
      }
    },
    handleMouseDown: function(event) {
      this.mouse.down = true;
      this.mouse.current = {
        x: event.pageX,
        y: event.pageY
      };
      this.lines.push([]);
      var canvasRef = this.$refs.canvas;
      var canvas = canvasRef.getContext("2d");
      var position = canvasRef.getBoundingClientRect();
      this.correctionX = position.x;
      this.correctionY = position.y;

      canvas.moveTo(this.currentMouse.x, this.currentMouse.y);
    },
    handleMouseUp: function() {
      this.mouse.down = false;
    },
    saveImg: function() {
      var canvasRef = this.$refs.canvas;
      if (!this.nameDelivered) {
        errorMessage("El nombre de la persona es obligatorio");
        return;
      }
      if (this.lines.length < 1) {
        errorMessage("Es necesario la firma");
        return;
      }
      this.url = canvasRef.toDataURL();
      const checklistPath = this.$route.query.checklistPath;
      this.saveSignChecklistTransportist({
        sign: canvasRef.toDataURL(),
        idItems: this.idItems,
        nameDelivered: this.nameDelivered,
        checklistPath
      });
      this.$router.push({
        name: this.isTransferRoute
          ? "signChecklistReceptorTransfer"
          : "signChecklistReceptor",
        params: {
          type: this.$route.params.type,
          step: 2
        },
        query: {
          checklistPath,
          path: this.$route.query.path,
          eventType: this.$route.params.eventType
        }
      });
    },
    clean: function() {
      this.lines = [];
      var canvasRef = this.$refs.canvas;

      var canvas = canvasRef.getContext("2d");

      canvas.clearRect(0, 0, this.width, 200);
      canvas.lineJoin = canvas.lineCap = "round";
      canvas.strokeStyle = "#000";
      canvas.lineWidth = 2;
      canvas.beginPath();
      this.lines.forEach(function(segment) {
        if (segment[0]) {
          canvas.moveTo(segment[0].x, segment[0].y);
          segment.forEach(function(point) {
            if (point.x && point.y) {
              canvas.lineTo(point.x, point.y);
            }
          });
        }
      });
      canvas.stroke();
    },
    handleMouseMove: function(event) {
      this.mouse.current = {
        x: event.pageX,
        y: event.pageY
      };

      this.draw(event);
    }
  },
  ready: function() {
    var canvasRef = this.$refs.canvas;
    var canvas = canvasRef.getContext("2d");
    canvas.translate(0.5, 0.5);
    canvas.imageSmoothingEnabled = false;
  }
};
</script>

<style scoped>
canvas {
  background: white;
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.2);
  border: 1px solid #000;
}
</style>
